import cd from "lodash-es/cloneDeep";

function iot(o: any, t: string) {
  return typeof o === t;
}

export function choice(a: any, b: any) {
  return a ? a : b;
}

export function parseDec(val: any) {
  return parseInt(val, 10);
}

export function setObjectValue(o: any, key: string, value: any) {
  if (isJsObject(o) && key && value) {
    o[key] = value;
  }
}

export function unsub(obs: any, returnValue: any = undefined) {
  try {
    obs && obs.unsubscribe();
  }catch(e) {

  }
  //obs && isFunction(obs.unsubscribe) && obs.unsubscribe();
  return returnValue;
}

export function toName(item: any) {
  return item.first_name + ' ' + item.last_name;
}

export function ensureArray(arr: any) {
  return Array.isArray(arr) ? arr : [];
}

export function firstArray(...arrays: any[]): any[] {
  for (var i = 0; i < arguments.length; i++) {
    if (Array.isArray(arguments[i])) {
      return arguments[i];
    }
  }
  return [];
}

export function firstNonEmpty(...arrays: any[]): any[] {
  for (var i = 0; i < arguments.length; i++) {
    if (Array.isArray(arguments[i]) && arguments[i].length) {
      return arguments[i];
    }
  }
  return [];
}

export function cloneDeep(obj: any): any {
  return cd(obj);
}

export function addCmToProperties(props: any) {
  if (props) {
    for (let k in props) {
      props[k] = props[k] + 'cm';
    }
  }
}

export function callFuncWith(f: any, arg: any) {
  isFunction(f) && f(arg);
}

export function parseFloatValueOrNull(d: any) {
  if (Number.isFinite(d)) {
    return d;
  }
  if (isAnyString(d)) {
    d = d.trim();
    d = parseFloat(d);
    if (isNaN(d)) {
      d = null;
    }
    return d;
  }
  return null;
}

/*
export function hasFileReader(): boolean {
  if (window.FileReader) {
    try {
      const r = new FileReader();
      return isFunction(r.readAsDataURL);
    } catch { }
  }
  return false;
}
*/

export function forEach(arr: any, f: any) {
  if (Array.isArray(arr)) {
    if (isFunction(arr.forEach)) {
      arr.forEach(f);
      return;
    }
    for (let i = 0; i < arr.length; i++) {
      f(arr[i], i, arr);
    }
  }
}

export function isNonEmptyArray(arr: any): boolean {
  return Array.isArray(arr) && arr.length > 0;
}

export function isNonEmptyString(str: any): boolean {
  return iot(str, 'string') && str.trim().length > 0;
}

export function to2Digits(h: number) {
  return ((h < 10) ? '0' : '') + h.toFixed(0);
}

export function floatToShortString(num: number | string) {
  const val = parseFloat(num as string);
  if (Number.isFinite(val)) {
    const res = val.toFixed(0);
    if (Number.parseFloat(res).toFixed(2) === val.toFixed(2)) {
      return res;
    }
  }
  return num;
}

export function isFunction(fn: any): fn is Function {
  return iot(fn, 'function');
}

export function ensureObject(obj: any) {
  return isJsObject(obj) ? obj : {};
}

export function isJsObject(obj: any) {
  return !!(obj && iot(obj, 'object') && !Array.isArray(obj));
}

export function isAnyString(value: any): value is string {
  return iot(value, 'string');
}

export function objectKeys(obj: any) {
  const keys: any[] = [];
  if (isJsObject(obj)) {
    if (isFunction(Object.keys)) {
      return Object.keys(obj);
    }
    for (let k in obj) {
      keys.push(k);
    }
  }

  return keys;
}

export function trimString(str: any, defaultValue = '') {
  if (iot(str, 'string')) {
    return str.trim();
  }
  return Number.isFinite(str) ? ('' + str) : defaultValue;
}

/*
export function removeAllFromString(str: string, letter: string) {
  if (typeof str === 'string') {
    while (str.indexOf(letter) >= 0) {
      str = str.replace('.', '');
    }
  }
  return str;
}
*/

export function setTeamNames(teams: any[]) {
  if (Array.isArray(teams)) {
    teams.forEach((item: any) => {
      if (!item.name) {
        item.name = (item.fname || '') + ' ' + (item.lname || '');
      }
      if ('team_number' in item && !Number.isFinite(item.team_number)) {
        const res = parseDec(item.team_number);
        if (!isNaN(res)) {
          item.team_number = res;
        }
      }
    });
  }
}

export function sortTeams(teams: any[]) {
  if (Array.isArray(teams)) {
    teams.sort((item1: any, item2: any) => {
      if (Number.isFinite(item1.team_number)) {
        if (Number.isFinite(item2.team_number)) {
          return item1.team_number - item2.team_number;
        }
        return 1;
      }
      if (Number.isFinite(item2.team_number)) {
        return 1;
      }
      return 0;
    });
  }
}

export interface ValidationError {
  name: string;
  error: string;
}

export function createValidationError(name: string, error: string): ValidationError {
  return {
    name,
    error
  };
}

/*
function showEmojii(id: string, code: string, options: any = {}): any {

  if (!id || !code) {
    return false;
  }
  // Verifies canvas is supported
  const elem = document.getElementById(id);
  if (!elem) {
    return false;
  }
  const canvas = document.createElement('canvas');
  if (!isFunction(canvas.getContext)) {
    return false;
  }

  const opts: any = {
    size: '60px',
    font: 'Arial'
  };

  Object.assign(opts, options);

  //canvas.style.height = opts.size;
  //canvas.style.width = opts.size;

  // Creates a 2d canvas context
  const ctx = canvas.getContext('2d');
  if (!ctx || !isFunction(ctx.fillText)) {
    return false;
  }

  let font = opts.size + ' ' + opts.font;

  ctx.textBaseline = 'top';
  ctx.font = font;
  // Renders an amoji within the canvas
  ctx.fillText(code, 0, 0);
  // Test whenever the median pixel within the emoji contains a non null value suggesting emoji are supported
  const res = ctx.getImageData(16, 16, 1, 1).data[0] !== 0;
  if (res) {
    return canvas;
    //elem.appendChild(canvas);
  }
  return false;
}
*/
